import { getIdToken, getIdTokenResult } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { isNativeiOS } from "../utils/platform";
import RevenueCatService from "../revenuecat/RevenueCatService";

export default async function isUserPremium() {
  if (!auth.currentUser) {
    console.warn("isUserPremium called with no authenticated user");
    return false;
  }

  try {
    // Force refresh the token to get latest claims
    await getIdToken(auth.currentUser, true);
    const decodedToken = await getIdTokenResult(auth.currentUser);

    const { stripeRole, lifetimePro } = decodedToken.claims;

    if (lifetimePro) {
      return "lifetime-pro";
    } else if (stripeRole === "premium") {
      return "premium";
    } else if (stripeRole === "designer-subscriber") {
      return "designer-subscriber";
    }

    // On iOS, check RevenueCat immediately — Firebase claims can take
    // 10–30s to propagate from the RC webhook, so RC is the fast path.
    if (isNativeiOS()) {
      try {
        const rc = RevenueCatService.getInstance();
        if (rc.isInitialized && rc.isSubscribed()) {
          console.log("[isUserPremium] RC entitlement active — treating as premium");
          return "revenuecat";
        }
      } catch (rcErr) {
        console.warn("[isUserPremium] RC check failed:", rcErr);
      }
    }

    return false;
  } catch (error) {
    console.error("Error checking premium status:", error);
    return false;
  }
}
